var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:`page-loading loading-position-${_vm.position} loading-${_vm.type}`},[_c('a-spin')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }